import $ from 'jquery';
import { FC, Fragment, useEffect, useState } from "react";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import Link from "../../common/Link";
import { NavbarItem } from "../Navbar";
import "./MobileNavbar.css";

const MobileNavbar: FC<{
    navLinkClickHandler: (linkId: string, elementId: string) => void,
    navbar: NavbarItem[]
}> = ({ navLinkClickHandler, navbar }) => {
    const [openSecondaryMenu, setOpenSecondaryMenu] = useState<boolean>(false);
    const [currentNavbarItem, setCurrentNavbarItem] = useState<NavbarItem | undefined>(undefined);
    const [show, setShow] = useState(false);

    function closeDropdowns() {
        var win = $(window);
        var width = win.width();
        if (typeof width !== 'undefined') {
            if (width > 768) {
                setOpenSecondaryMenu(false);
                setShow(false)
            }
        }
    }

    useEffect(() => {
        closeDropdowns()
        $(window).on('resize', function () {
            closeDropdowns()
        });
    }, []);


    const getSubRoutesContent = (item: NavbarItem, index: number, href?: string) => {
        return item.headerNavbar ? <Col key={index} className='ps-5'>
            {
                !item.path || !href ? <span
                    className="disabled-route nav-link"
                    title={item.name}
                >
                    {item.name}
                </span> : <Link
                    className="title-route nav-link"
                    href={href}
                    title={item.name}
                >
                    {item.name}
                </Link>
            }
            {
                item.subRoutes && item.subRoutes.length ? (
                    <ul id={`navbar-${item.id}-dropdown-items`} className="">
                        {
                            item.subRoutes.map((item3: NavbarItem, index3: number) => {
                                let href3 = typeof item3.path !== 'undefined'
                                    ? (currentNavbarItem?.path ?? '') + (item.path ?? '') + item3.path
                                    : undefined;
                                return item3.headerNavbar ? <li key={index3}>
                                    {
                                        !item3.path || !href3 ? <span
                                            className="nav-link"
                                            title={item3.name}
                                        >
                                            {item3.name}
                                        </span> : <Link
                                            className="nav-link"
                                            href={href3}
                                            title={item3.name}
                                            onClick={() => setOpenSecondaryMenu(false)}
                                        >
                                            {item3.name}
                                        </Link>
                                    }
                                </li> : <Fragment key={index3}></Fragment>
                            })
                        }
                    </ul>
                ): <Fragment />}
        </Col> : <Fragment key={index}></Fragment>
    }

    return <>
        <Dropdown
            id="mobile-dropdown-main"
            className="d-flex align-items-center d-md-none"
            align={"start"}
            show={show}
            onToggle={(isOpen) => {
                setShow(isOpen)
                navLinkClickHandler('navbar-search-link', 'navbar-search')
                if (!isOpen)
                    setOpenSecondaryMenu(false)
            }}>
            <Dropdown.Toggle id="mobile-dropdown" data-target="#mobile-dropdown-menu" className="float-end border-0 shadow-none">
                <span className="navbar-toggler-icon"></span>
            </Dropdown.Toggle>
            <Dropdown.Menu id="mobile-dropdown-menu" className="mobile-dropdown-menu d-md-none" align="start">
                {
                    navbar.filter(item => item.headerNavbar).map((item: NavbarItem, index: number) => {
                        return item.subRoutes?.length ? (
                            <Dropdown.Item
                                id={`navbar-${item.id}`}
                                key={index}
                                className="nav-item"
                                title={item.name}
                                as={Link}
                                isDropdown
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setOpenSecondaryMenu(true)
                                    setCurrentNavbarItem(item)
                                }}
                            // onClick={() => navLinkClickHandler('navbar-search-link', 'navbar-search')}
                            >
                                {item.name}
                            </Dropdown.Item>
                        ) : (
                            <Dropdown.Item
                                key={index}
                                className="nav-item"
                                href={item.path ? item.path : undefined}
                                as={Link}
                            >
                                {item.name}
                            </Dropdown.Item>
                        )
                    })
                }
            </Dropdown.Menu>
        </Dropdown>
        {
            openSecondaryMenu && <div className="mobile-secondary-menu position-absolute">
                <>
                    <Button
                        className="back-btn nav-link d-flex align-items-center"
                        onClick={(event) => {
                            event.stopPropagation()
                            setOpenSecondaryMenu(false)
                        }}
                    >
                        <svg className="me-3" width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.908034 12.5694L15.2262 20.8761C16.4419 21.5813 18 20.7283 18 19.3094V2.69598C18 1.27706 16.4419 0.424047 15.2262 1.12931L0.908034 9.43601C-0.302678 10.1384 -0.302678 11.867 0.908034 12.5694Z" fill="#E63F4B" />
                        </svg>
                        {currentNavbarItem?.name}
                    </Button>
                    {
                        <Row className='mt-4'>
                            {
                                currentNavbarItem && currentNavbarItem.subRoutes && currentNavbarItem.subRoutes.slice(0, 1).map(
                                    (item2: NavbarItem, index2: number) => {
                                        let href2 = typeof item2.path !== 'undefined' ? (currentNavbarItem.path ?? '') + item2.path : undefined;
                                        return getSubRoutesContent(item2, index2, href2)
                                    }
                                )
                            }
                            {
                                currentNavbarItem && currentNavbarItem.subRoutes && currentNavbarItem.subRoutes.slice(1, 2).map(
                                    (item2: NavbarItem, index2: number) => {
                                        let href2 = typeof item2.path !== 'undefined' ? (currentNavbarItem.path ?? '') + item2.path : undefined;
                                        return getSubRoutesContent(item2, index2, href2)
                                    }
                                )
                            }
                            {
                                currentNavbarItem && currentNavbarItem.subRoutes && currentNavbarItem.subRoutes.slice(2, 3).map(
                                    (item2: NavbarItem, index2: number) => {
                                        let href2 = typeof item2.path !== 'undefined' ? (currentNavbarItem.path ?? '') + item2.path : undefined;
                                        return getSubRoutesContent(item2, index2, href2)
                                    }
                                )
                            }
                        </Row>
                    }
                </>
            </div>
        }
    </>
}

export default MobileNavbar;